import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ButtonComponent } from "../../shared/button/button.component";

@Component({
  selector: "app-demo",
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: "./demo.component.html",
  styleUrl: "./demo.component.css",
})
export class DemoComponent implements OnInit {
  public code: any;

  constructor(
    private activeRoute: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    this.code = this.activeRoute.snapshot.queryParamMap.get("code");
  }
}
